import '@availity/block-ui/src/BlockUi.css';
import "react-datepicker/dist/react-datepicker.css";

import React, { Component } from "react";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import {AsyncPaginate} from 'react-select-async-paginate';

import { callBackendAPI, handleFormValidation,handleFormInputs, generateSource, cancelToken  } from './../../helpers/common';
import {STATUS_SUCCESS, RADIO_YES, RADIO_NO, REQUEST_DEPARTMENT_DROPDOWN, ACTIVE }  from './../../config/global_constants';
import { translate  } from './../../helpers/intl_helpers';
import { UserDetails }  from './../../UserDetails';

class AddSubContractorForm extends Component {
	source;

	static contextType = UserDetails;

	constructor(props) {
        super(props)

		// Access context here

        this.state = {
			isLoading		: true,
			errors			: {},
			fields			: {
				request_date: {value: new Date()},
				is_job_number:  {value: String(RADIO_YES)},
			},
			submitted		: false,
			fileUrl			: "",
			imageSrc		: "",
			croppedImage	: "",
			fullName 		: "",
			serviceTypeList : [],
            jobNumberList   : [],
            userArr   		: [],
			companyList   	: [],
        };

		this.onCropComplete				= this.onCropComplete.bind(this);
		this.handleFormInputs 			= this.handleFormInputs.bind(this);
		this.handleFormSubmit 			= this.handleFormSubmit.bind(this);
		this.loadOptions 				= this.loadOptions.bind(this);
    }

	/** This function invoked immediately after a component is mounted.
	 * Its use to manage initial data fetch.
	 */
	componentDidMount() {
		/** Generate source for cancel token */
		this.source = generateSource();

		window.showLoader();

		let apiParams = [
			{ model: 'home', 	 method: 'masterList', type: ["service_type","company"] },
            { model: 'calendar', method: 'cannonJobList' },
		];

		/** Call API */
		callBackendAPI(apiParams,this.source).then(response => {
			if(response.success && response.data[0].status === STATUS_SUCCESS && response.data[0].result) {
				const { userDetails } = this.context;

				this.setState({companyList: response?.data?.[0]?.result?.company})
				let tmpstamp	=	{
					serviceTypeList		: response.data[0].result.service_type,
					jobNumberList       : response.data[1].result,
					fields: {
						...this.state.fields,
						requestor_name: userDetails?._id ? { value: userDetails._id, label: `${userDetails.first_name} ${userDetails.last_name}` } : null
					}
				};
				this.setState(tmpstamp,()=>{
					window.hideLoader();
				});
			}
		}).catch(err => console.log(err));
    }

	componentWillUnmount(){
		cancelToken(this.source); // cancel the request
	}

	/**
	* For load project manager options
	*
	* @param inputValue		as 	search term
	* @param loadedOptions	as 	old options array
	* @param page			as 	page count
	*
	* @return json
	*/
	async loadOptions(inputValue, loadedOptions, { page }) {
		try{
			/** Generate source for cancel token */
			this.source = generateSource();

			let response = await callBackendAPI([{ model: 'calendar', method: 'employeeList', is_project_manager: true ,current_page: page, emp_name: inputValue ? inputValue : ''}],this.source);

			let resData 		= 	response && response.data && response.data[0] ? response.data[0] :{};
			let result 			=	resData.result ? resData.result :[];
			let recordsTotal 	=	resData.recordsTotal ? resData.recordsTotal:0;
			let completeArray 	=	result.concat(loadedOptions);

			return {
				options		:	result,
				hasMore		:	completeArray.length  === recordsTotal ? false :true,
				additional	: 	{page: page + 1},
			}

		} catch (error) {
			console.error('Error loading options:', error);
			return {
				options		: 	[],
				hasMore		:	false,
				additional	: 	{page: page},
			};
		}
	}

	/**
	* For manage form submit event
	*
	* @param e 	as 	current form object
	*
	* @return null
	*/
	handleFormSubmit(e){
		e.preventDefault();

		const {company_name,contact_name,email,mobile_number,request_date,is_job_number,job_number,project_name,estimated_start_date,service_type,requestor_name,department,department_manager,justification,company} = this.state.fields;

		let serviceTypeArr   = [];
		let departmentManagerArr   = [];
		let companyArr   = [];
		if(service_type && service_type.length) serviceTypeArr = service_type.map(element => element.value);
		if(department_manager && department_manager.length) departmentManagerArr = department_manager.map(element => element.value);
		if(company && company.length) companyArr = company.map(element => element.value);
		this.setState({
			submitted: true,
			fields      :   {
                ...this.state.fields,
                ...{
                    service_type_err: {value: serviceTypeArr.length ? serviceTypeArr : null},
                    department_manager_err: {value: departmentManagerArr.length ? departmentManagerArr : null},
					company_err: {value: companyArr.length ? companyArr : null},
                }
            }
		}, () =>{

			/** Api Requested Data **/
			let params = [{
				model				: 	'employee',
				method				: 	'addSubcontractorRequest',
				company_name 		: 	company_name && company_name.value  ? company_name.value	:"",
				contact_name		: 	(contact_name && contact_name.value)			?	contact_name.value		:"",
				email				: 	(email && email.value)							?	email.value				:"",
				mobile_number		: 	(mobile_number && mobile_number.value)			?	mobile_number.value		:"",
				request_date		: 	(request_date && request_date.value)			?	request_date.value		:"",
				is_job_number		:	(is_job_number && is_job_number.value)			?	is_job_number.value		:"",
				job_number			: 	(job_number && job_number.value)				?	job_number.value		:"",
				project_name			: 	(project_name && project_name.value)					?	project_name.value			:"",
				estimated_start_date: 	(estimated_start_date && estimated_start_date.value)?	estimated_start_date.value	:"",
				service_type		: 	serviceTypeArr,
				requestor_id		: 	(requestor_name && requestor_name.value)		?	requestor_name.value		:"",
				department			:	(department && department.value)				?	department.value			:"",
				// department_manager	:	departmentManagerArr,
				justification		:	(justification && justification.value)			?	justification.value			:"",
				company				: 	companyArr,
			}];

			/** Validation Rules **/
			let validations = {
				company_name	: {"label": translate('company_name','Company Name'), "rules" :["required"]},
				contact_name		: {"label": translate('contact_name','Contact Name'), "rules" :["required"]},
				email				: {"label": translate('contact_email','Contact Email'), "rules" :["required", "email"]},
				mobile_number		: {"label": translate('mobile_number','Contact Phone'), "rules" :["required"]},
				request_date		: {"label": translate('request_date','Request Date'), "rules" :["select"]},
				requestor_name		: {"label": translate('requestor_name','Request Name'), "rules" :["select"]},
				is_job_number		: {"label": translate('is_job_number','Is Job Number'), "rules" :["required"]},
				estimated_start_date: {"label": translate('estimated_start_date','Estimated Start Date'), "rules" :["select"]},
				service_type_err	: {"label": translate('service_type','Service Type'), "rules" :["select"]},
				department			: {"label": translate('department','Department'), "rules" :["select"]},
				justification		: {"label": translate('justification','Scope of Work'), "rules" :["required"]},
				company_err			: {"label": translate('service_type','Service Type'), "rules" :["select"]},
			}

			if(is_job_number && is_job_number.value === String(RADIO_YES)){
                validations['job_number'] = { "label": translate('job.job_number'), "rules" :["select"] };
            }

			/** Handle validation and api response **/
			handleFormValidation(validations,this.state.fields, params, true,true,true).then(async (response) =>{
				if(!response.success){
					if(response.errors && response.data){

						this.setState({ errors : response.errors, submitted: false});
					}else if(response.errors){
						this.setState({ errors : response.errors, submitted: false})
					}
				}else{
					/** Call parent function */
					if(this.props.updateEventCalendar) this.props.updateEventCalendar(null,"calendar");
					/** Hide loader */
					this.closeModal();
				}

			}).catch(err => console.log(err));
		});
	}

	/**
	* For get users listing
	*/
    getUserListByDepartment = (fieldVal) =>{
		/** Generate source for cancel token */
		this.source = generateSource();

		/** Call API for work order list */
	   	callBackendAPI([{ model: 'employee', method: 'getUsersList', department: fieldVal.value, is_all: true }],this.source).then(response => {
		   	if(response.success && response.data[0].status === STATUS_SUCCESS && response.data[0].result){

			   	this.setState({
				   userArr: response.data[0].result,
			   	});
		   	}
	   }).catch(err => console.log(err));
   	}// end getUserListByDepartment()

	/**
	* For hide model
	*
	* @return null
	*/
	closeModal() {
		window.document.body.classList.remove("modal-open");
		window.document.body.classList.remove("overflow-hidden");

		this.props.requestModal(false);
	}// end closeModal()

	/**
	* For update state fields values
	*
	* @param e  	as current field object
	* @param field  as current field name
	*
	* @return null
	*/
	handleFormInputs(e, field){
		let response	=	handleFormInputs(e, field, this.state.fields);
		this.setState({ response },()=>{
            if(field === "is_job_number" && this.state.fields.is_job_number && this.state.fields.is_job_number.value !== RADIO_NO){
                this.setState(prevState => ({
					fields: {
						...prevState.fields,
						job_number: null,
					}
				}));
            }
        });
	}// end handleFormInputs()

	/**
	 * Handle dropdown value state
	 */
	 handleChange = (fieldName) => (fieldVal) => {
		let newObj = {[fieldName]: fieldVal};

		let updatedFields = {...this.state.fields, ...newObj};

        if(fieldName === "department"){
			updatedFields['department_manager'] = null;
			this.getUserListByDepartment(fieldVal);
		}
		if(fieldName === "job_number"){
			updatedFields.project_name = (fieldVal && fieldVal.project_name) ? {value: fieldVal.project_name}  : "";
		}

        this.setState({fields: updatedFields});
    }; // end handleChange()

	onCropComplete = (croppedImage) => {
		this.setState({ croppedImage });
	};

	render() {
		const {fields,errors, jobNumberList, serviceTypeList,submitted} = this.state;

		return <>
			<div
				className={`modal fade show d-block subcontractor-modal`}
				id="adduserModal"
				tabIndex={-1}
				aria-labelledby="adduserModal"
				aria-hidden="true"
			>
				<div className="modal-dialog modal-dialog-centered modal-xl">
					<div className="modal-content">
						<button
							type="button"
							className="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							onClick={() => this.closeModal()}
						>
							X {translate("system.close")}
						</button>
						<div className="modal-body">
							<h2 className="modal-title" id="requestModalLabel">{translate("subcontractor.subcontractor_request")}</h2>
							<form className="request-field" onSubmit={(event) => this.handleFormSubmit(event, 'AddSubContractorJob')} noValidate>
								<div className="row">
									<div className="col-md-12 mb-4">
										<span className="fields-label-text">{translate("subcontractor.contact_information")}</span>
										<div className="fields-label">
											<div className="row">
												<div className="col-md-6 col-xl-4">
													<div className="form-group mb-3">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.subcontractor_company_name")}<span className="error text-danger">*</span></label>
														<input
															type="text"
															className="form-control input-with-label"
															name="company_name"
															id="company_name"
															placeholder="Company Name"
															value={fields.company_name ? fields.company_name.value : ""}
															onChange={(e) => this.handleFormInputs(e, 'company_name')}
														/>
														<span className="error text-danger">{errors["company_name"]}</span>
													</div>
												</div>
												<div className="col-md-6 col-xl-4">
													<div className="form-group mb-3">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.contact_name")}<span className="error text-danger">*</span></label>
														<input
															type="text"
															className="form-control input-with-label"
															id="contact_name"
															placeholder={translate("subcontractor.contact_name")}
															value={fields.contact_name ? fields.contact_name.value : ""}
															onChange={(e) => this.handleFormInputs(e, 'contact_name')}
														/>
														<span className="error text-danger">{errors["contact_name"]}</span>
													</div>
												</div>
												<div className="col-md-6 col-xl-4">
													<div className="form-group mb-3">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.contact_email")}<span className="error text-danger">*</span></label>
														<input
															type="text"
															className="form-control input-with-label"
															id="email"
															placeholder={translate("subcontractor.contact_email")}
															value={fields.email ? fields.email.value : ""}
															onChange={(e) => this.handleFormInputs(e, 'email')}
														/>
														<span className="error text-danger">{errors["email"]}</span>
													</div>
												</div>
												<div className="col-md-6 col-xl-6">
													<div className="form-group mb-3">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.contact_phone")}<span className="error text-danger">*</span></label>
														<input
															type="text"
															placeholder={translate("subcontractor.contact_phone")}
															className="form-control input-with-label"
															data-bs-backdrop="static"
															value={fields.mobile_number ? fields.mobile_number.value: ""}
															onChange={(e) => this.handleFormInputs(e, 'mobile_number')}
														/>
														<span className="error text-danger">{errors["mobile_number"]}</span>
													</div>
												</div>
												<div className="col-md-6 col-xl-6">
													<div className="form-group mb-3">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.request_date")}<span className="error text-danger">*</span></label>
														<DatePicker
															className="form-control input-with-label"
															selected={fields.request_date && fields.request_date.value ? fields.request_date.value :null}
															onChange={(date) => {this.setState({ fields : {...fields, ...{request_date:{value: date} }} }) }}
															placeholderText={translate("settings.select_request_date")}
															dropdownMode="select"
															showMonthDropdown
															showYearDropdown
														/>
														<span className="error text-danger">{errors["request_date"]}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-12">
										<span className="fields-label-text">{translate("subcontractor.job_details")}</span>
										<div className="fields-label">
											<div className="row">
												<div className="col-md-6 col-xl-4">
													<div className="form-group mb-3 custom-form-group">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.company")}<span className="error text-danger">*</span></label>
														<Select
															className="custom-react-select"
															placeholder={<label htmlFor={"company"}>Select Company</label>}
															options={this.state.companyList}
															value={fields["company"] ? fields["company"] : null}
															closeMenuOnSelect={true}
															isClearable={true}
															onChange={this.handleChange('company')}
															components={{IndicatorSeparator: () => null}}
															isMulti
														/>
														<span className="error text-danger">{errors["company_err"]}</span>
													</div>
												</div>
												<div className="col-md-6 col-xl-4">
													<div className="form-group mb-3 form-check-group">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.do_you_have_job_number")}<span
															className="error text-danger">*</span></label>
														<div className="form-group checkbox-row employee-checkbox-row">
															<div className="form-check form-check-inline custom-checkbox">
																<input className="form-check-input" type="radio" name="is_job_number" id="is_job_numberyes" value={RADIO_YES} onChange={(e) => this.handleFormInputs(e, "is_job_number")} defaultChecked={fields.is_job_number && fields.is_job_number.value === String(RADIO_YES) ? true :false}/>
																<label className="form-check-label" htmlFor="is_job_numberyes">
																{translate('calendar.yes')}
																</label>
															</div>
															<div className="form-check form-check-inline custom-checkbox">
																<input className="form-check-input" type="radio" name="is_job_number" id="is_job_numberno" value={RADIO_NO} onChange={(e) => this.handleFormInputs(e, "is_job_number")} defaultChecked={fields.is_job_number && fields.is_job_number.value === String(RADIO_NO) ? true :false} />
																<label className="form-check-label" htmlFor="is_job_numberno">
																{translate('calendar.no')}
																</label>
															</div>
														</div>
													</div>
												</div>
												{(fields.is_job_number && fields.is_job_number.value === String(ACTIVE)) &&
													<div className="col-md-6 col-xl-4">
														<div className="form-group mb-3 custom-form-group">
															<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.job_number")}<span className="error text-danger">*</span></label>
															<Select
																className="custom-react-select"
																value={fields.job_number  ? fields.job_number : null}
																options={jobNumberList}
																onChange={this.handleChange("job_number")}
																closeMenuOnSelect={true}
																placeholder={translate('calendar.select_job_number')}
															/>
															<span className="error text-danger">{errors["job_number"]}</span>
														</div>
													</div>
												}
												<div className="col-md-6 col-xl-4">
													<div className="form-group mb-3">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.project_name")}</label>
														<input
															type="text"
															className="form-control input-with-label"
															id="project_name"
															placeholder="Project Name"
															value={fields.project_name ? fields.project_name.value : ""}
															onChange={(e) => this.handleFormInputs(e, 'project_name')}
														/>
														<span className="error text-danger">{errors["project_name"]}</span>
													</div>
												</div>
												<div className="col-md-6 col-xl-4">
													<div className="form-group mb-3">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.estimated_start_date")}<span className="error text-danger">*</span></label>
														<DatePicker
															className="form-control input-with-label"
															selected={fields.estimated_start_date && fields.estimated_start_date.value ? fields.estimated_start_date.value :null}
															onChange={(date) => {this.setState({ fields : {...fields, ...{estimated_start_date:{value: date} }} }) }}
															placeholderText={translate("settings.select_estimated_start_date")}
															dropdownMode="select"
															showMonthDropdown
															showYearDropdown
														/>
														<span className="error text-danger">{errors["estimated_start_date"]}</span>
													</div>
												</div>
												<div className="col-md-6 col-xl-4">
													<div className="form-group mb-3 custom-form-group">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.service_type")}<span className="error text-danger">*</span></label>
														<Select
															className="custom-react-select"
															placeholder={<label htmlFor={"service_type"}>{translate("Select Service Type")}</label>}
															options={serviceTypeList}
															value={fields["service_type"] ? fields["service_type"] : null}
															closeMenuOnSelect={true}
															onChange={this.handleChange("service_type")}
															isMulti
														/>
														<span className="error text-danger">{errors["service_type"]}</span>
														<span className="error text-danger">{errors["service_type_err"]}</span>
													</div>
												</div>
												<div className="col-md-6 col-xl-4">
													<div className="form-group mb-3 custom-form-group">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.requestor_name")}<span className="error text-danger">*</span></label>
														<AsyncPaginate
															className="custom-react-select"
															value={fields.requestor_name ? fields.requestor_name : null}
															loadOptions={this.loadOptions}
															onChange={this.handleChange("requestor_name")}
															placeholder={<label htmlFor={"requestor_name"}>{translate("Select Requestor Name")}</label>}
															additional={{ page: 1 }}
														/>
														<span className="error text-danger">{errors["requestor_name"]}</span>
													</div>
												</div>
												<div className="col-md-6 col-xl-4">
													<div className="form-group mb-3 custom-form-group">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.department")}<span className="error text-danger">*</span></label>
														<Select
															className="custom-react-select"
															placeholder={<label htmlFor={"department"}>Select Department</label>}
															options={REQUEST_DEPARTMENT_DROPDOWN}
															value={fields["department"] ? fields["department"] : null}
															closeMenuOnSelect={true}
															onChange={this.handleChange("department")}
														/>
														<span className="error text-danger">{errors["department"]}</span>
													</div>
												</div>
												<div className="col-md-12">
													<div className="form-group mb-3">
														<label className="mb-1 form-label" htmlFor="ticket_number3">{translate("subcontractor.justification")}<span className="error text-danger">*</span></label>
														<textarea type="justification" className="form-control" name='justification' id='justification' value={fields["justification"] ? fields["justification"]["value"] : ""} placeholder={translate("subcontractor.enter_scope_of_work")} onChange={(event) => this.handleFormInputs(event, "justification")}></textarea>
														<span className="error text-danger">{errors["justification"]}</span>
													</div>
												</div>

											</div>
										</div>
									</div>
								</div>
								<div className="comman-submit-btn">
									<div className="left-box d-flex flex-wrap align-items-center">
										<button type={submitted ? "button" : "submit"} className="btn btn-fill">
											{translate("system.submit")} {submitted && <i className="spinner-border spinner-border-sm  ms-3"/>}
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<div className="modal-backdrop fade show"></div>


		</>
	}
}
export default AddSubContractorForm;